export default "__VITE_ASSET__cY4ClzbM__"